export const EnvType = {
  /**生产 */
  prod: 'prod',
  /**灰度 */
  pre: 'pre',
  /**测试 */
  test: 'test',
  /**开发 */
  dev: 'dev'
}

export const HostType = {
  platformApi: 'platformApi',
  epicureApi: 'epicureApi',
  passportApi: 'passportApi',
  platformOldApi: 'platformOldApi'
}
